/* this file is transformed by vux-loader */
/* eslint-disable */
import _regenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/pm-ningde/ppos-web-propertyManage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "@/components/BottomNav";
import XInput from "vux/src/components/x-input/index.vue";
import Group from "vux/src/components/group/index.vue"; // import { personnelMe, coachAvatarAdd } from '@/api/mine'
import { getAdmInfo } from "@/api/me";
import Vue from "vue";
export default {
  components: {
    XInput: XInput,
    Group: Group,
    BottomNav: BottomNav
  },
  data: function data() {
    return {
      info: {
        // 'user_name': 'super',
        // 'user_realname': '超级管理员',
        // 'user_gender': '男',
        // 'user_mobile': '13632619581',
        // 'user_img': 'http://192.168.1.200:8055/img001/1/personalLogo/1803/29/1e/2a/2f/1e2a2f14babb446043ed3d23913394e8.jpg?w=100&h=100'
      },
      // showShadow: false,
      readonly: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function (res) {
      _this.getInfo();
    });
  },
  methods: {
    getInfo: function getInfo() {
      this.getAdmInfoEvent();
    },
    loginOut: function loginOut() {
      var _this2 = this;
      this.$vux.loading.show();
      this.$store.dispatch("LogOut").then(function () {
        _this2.$vux.loading.hide();
        Vue.$vux.toast.show({
          text: "退出成功",
          type: "success",
          time: 2 * 1000
        });
        // 登录成功后重定向到首页
        _this2.$router.push({
          path: "/login"
        });
      }).catch(function (err) {
        _this2.$vux.loading.hide();
        _this2.$message.error(err); // 登录失败提示错误
      });
    },
    getAdmInfoEvent: function getAdmInfoEvent() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                related_no: _this3.related_no
              };
              _context.n = 1;
              return getAdmInfo(param);
            case 1:
              data = _context.v;
              if (!data.is_error) {
                _this3.info = data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  }
};